import { FormField, Checkbox, LabeledControl, Label, Alert, Switch, Text } from '@zillow/constellation';
import { Field, FieldProps } from 'formik';
import React from 'react';

export const VoidCheckInHand: React.FC = () => {
  return (
    <Field name="checkInHand">
      {({ field: { value: checked, ...field } }: FieldProps<boolean>) => (
        <>
          <FormField label="Check in Hand*" control={<Switch checkbox={<Checkbox {...field} checked={checked} />} />} />
          <Field name="confirmation">
            {({ field }: FieldProps<boolean>) => (
              <LabeledControl
                label={<Label>Confirm {checked ? 'Check in Hand' : 'No Check in Hand'}</Label>}
                control={<Checkbox {...field} value={undefined} checked={field.value} />}
              />
            )}
          </Field>
          <Text>
            <strong>Stop Pay is {checked ? 'not' : ''} Needed</strong>
          </Text>
          {checked === false && (
            <Alert
              appearance="warning"
              body={
                'If you do not have the check in hand, you will not be able to reissue until 2 PM the following business day.'
              }
            ></Alert>
          )}
        </>
      )}
    </Field>
  );
};
